import React from 'react';
import { Container } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

const { REACT_APP_ROOT_URL } = process.env;

const CampaignNotFound = () => {
  const [translate] = useTranslation();

  return (
    <Container className="text-center">
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="py-5 text-primary">
        <FontAwesomeIcon icon={faQuestionCircle} size="6x" />
      </div>
      <h1 className="py-5 text-primary fw-bold">
        {translate('COMMON.NO_CAMPAIGN')}
      </h1>
      <p>{translate('COMMON.NO_TYPOS')}</p>
      <a href={REACT_APP_ROOT_URL}>
        {translate('COMMON.ROOT_LINK_LABEL')}
      </a>
    </Container>
  );
};

export default CampaignNotFound;
